import { render, staticRenderFns } from "./baseEdit.vue?vue&type=template&id=35d8c2d6&scoped=true&"
import script from "./baseEdit.vue?vue&type=script&lang=js&"
export * from "./baseEdit.vue?vue&type=script&lang=js&"
import style0 from "./baseEdit.vue?vue&type=style&index=0&id=35d8c2d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8c2d6",
  null
  
)

export default component.exports